const VERSION = "1.2.37"; export default VERSION;
